<shared-header *ngIf="isDesktop"></shared-header>
<shared-navigation-main *ngIf="isDesktop"></shared-navigation-main>

<router-outlet></router-outlet>

<shared-footer *ngIf="isDesktop"></shared-footer>
